import { createContext } from "react";

/**
 * The document portalled UI should mount into; `null` means the main window.
 * Set by `layout/window/PopoutPortal` so nested `Modal`s land in the detached
 * window instead of jumping back to the main tab.
 */
export const PortalTargetContext = createContext<Document | null>(null);
